import { createUseQueryHook } from '@iheartjane/react-query-utils';
import { isOngoingReservationStatus } from '@iheartjane/types';

import type {
  GuestReservationDetailsProps,
  ReservationDetailsProps,
  ReservationsProps,
} from './reservations.api';
import {
  fetchGuestReservationDetails,
  fetchReservationDetails,
  fetchReservations,
} from './reservations.api';
import type {
  CustomerReservationDetails,
  CustomerReservationHistory,
  GuestCustomerReservationDetails,
} from './reservations.types';

const fetchInProgressReservations = async (props: ReservationsProps) => {
  const reservations = await fetchReservations(props);

  return reservations.filter((reservation) =>
    isOngoingReservationStatus(reservation.status)
  );
};

export const RESERVATIONS_BASE_KEY = 'reservations';
const reservationsKeys = {
  reservations: ({ storeId }: ReservationsProps) => [
    RESERVATIONS_BASE_KEY,
    storeId,
  ],
  reservationsInProgress: ({ storeId }: ReservationsProps) => [
    RESERVATIONS_BASE_KEY,
    'in_progress',
    storeId,
  ],
  reservationDetails: ({ id }: ReservationDetailsProps) => [
    RESERVATIONS_BASE_KEY,
    id,
  ],
  guestReservationDetails: ({ id }: GuestReservationDetailsProps) => [
    RESERVATIONS_BASE_KEY,
    'guest',
    id,
  ],
  // notifyCurbsideArrival: ({ id }: ReservationRequestProps) => [
  //   RESERVATIONS_BASE_KEY,
  //   'curbside_arrival',
  //   id,
  // ],
};

export const useReservations = createUseQueryHook<
  ReservationsProps,
  CustomerReservationHistory[]
>(fetchReservations, reservationsKeys.reservations, ({ enabled }) => !!enabled);

export const useInProgressReservations = createUseQueryHook<
  ReservationsProps,
  CustomerReservationHistory[]
>(
  fetchInProgressReservations,
  reservationsKeys.reservationsInProgress,
  ({ enabled }) => !!enabled
);

export const useReservationDetails = createUseQueryHook<
  ReservationDetailsProps,
  CustomerReservationDetails
>(
  fetchReservationDetails,
  reservationsKeys.reservationDetails,
  ({ id }) => !!id
);

export const useGuestReservationDetails = createUseQueryHook<
  GuestReservationDetailsProps,
  GuestCustomerReservationDetails
>(
  fetchGuestReservationDetails,
  reservationsKeys.guestReservationDetails,
  ({ id }) => !!id
);
